
import { Component, Vue } from 'vue-property-decorator'
import DesktopFooter from '@/components/DesktopFooter.vue'

@Component({
  components: {
    DesktopFooter
  }
})
export default class perfil extends Vue {}
